import { keyring_original_product_faces2 } from './product_mock.js';

export const PRODUCT = {
  acrylic_figure: {
    bottoms: [
      {
        bp_option_id: 532,
        bp_option_group_id: 199,
        size: 'M',
        stand_bottom: {
          x: 503,
          y: 19,
          url: '//s3.marpple.co/files/u_193535/2023/5/original/31a7389fe8f44d1140a7905ef8d6095072b7ac3f2.png',
          cm_width: 85,
          /* mm 입니다. */
          cm_height: 40,
        },
      },
      {
        size: 'L',
        bp_option_id: 533,
        bp_option_group_id: 199,
        stand_bottom: {
          x: 710,
          y: 20,
          url: '//s3.marpple.co/files/u_193535/2023/5/original/c689546e886a2445578396eba2dcfc32801303ad1.png',
          cm_width: 120,
          cm_height: 60,
        },
      },
    ],
  },
  keyring_original_product_faces2,
};

export const SALE_INFO_TYPE = {
  SOLD_OUT: 'sold_out',
  PERIOD_LIMIT: 'period_limit',
  QUANTITY_LIMIT: 'quantity_limit',
  READY: 'ready',
  DEFAULT: 'default',
};

/**
 * ### LABS 추천 상품 목록 우선순위 (하드코딩)
 * @description 상품 상세 페이지의 하단에 등장하는 상품 목록의 우선순위를 결정합니다.
 * 22052966(데스크패드 - 클래식), 21285911(아크릴 키링), 21117800(아크릴 스탠드), 21285904(무드등 - 아르카나), 21118306(포토카드 - 바이올렛), 21542125(폰케이스-시그니처)
 */
export const PRODUCT_RECOMMEND_PRIORITY = [22052966, 21285911, 21117800, 21285904, 21118306, 21542125];

/**
 * ### LABS EA 상품 목록 (하드코딩)
 * @description EA 뱃지를 달 상품 목록입니다.
 *
 * !! 빈 기간이 없게 설정해주세요.
 * @type {number[]}
 */
export const PRODUCT_EA_LIST = [
  {
    // 2025-05-20 23:00:00 ~ NOW
    start_at: new Date('2025-05-20T23:00:00+09:00'),
    end_at: new Date('2025-05-28T11:00:00+09:00'),
    product_ids: [22057204, 22052966, 22055163, 22055266, 22055164, 22055269, 22055167, 22055271], // 장패드
  },
  {
    // 2000-01-01 11:00:00 ~ 2025-05-21 11:00:00
    start_at: new Date('2000-01-01T11:00:00+09:00'),
    end_at: new Date('2025-05-21T11:00:00+09:00'),
    product_ids: [21541935, 21541932, 21541804, 21541809, 21542125, 21542107, 21541953, 21541973], // 핸드폰 케이스
  },
];
